import React, { useState } from 'react';

const CatalogThumb = ({ video, index, listLength }) => {
    const [broken, setBroken] = useState(false);

    if (video.thumbnailSprite) {
        return (
            <span
                className="video-thumbnail-sprite"
                style={{
                    backgroundImage: `url(${video.thumbnailSprite})`,
                    backgroundPosition: `center ${((video.thumbnailIndex ?? index) / Math.max(listLength - 1, 1)) * 100}%`
                }}
                role="img"
                aria-label=""
            />
        );
    }

    if (video.thumbnail && !broken) {
        return (
            <img
                src={video.thumbnail}
                alt=""
                onError={() => setBroken(true)}
            />
        );
    }

    return (
        <div className="thumbnail-placeholder" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M10 9l5 3-5 3V9z" fill="currentColor"/>
            </svg>
        </div>
    );
};

const cleanTitle = (title) => {
    if (!title) return 'Untitled Video';
    return String(title)
        .replace(/\+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

const VideoGrid = ({ videos, loading, onVideoSelect, selectedVideo }) => {

    if (loading) {
        return (
            <div className="loading-container">
                <div className="modern-spinner"></div>
            </div>
        );
    }

    const formatDuration = (duration) => {
        if (!duration) return '0:00';
        if (typeof duration === 'string' && duration.includes(':')) {
            return duration;
        }
        const minutes = Math.floor(duration / 60);
        const seconds = duration % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    const formatViewCount = (count) => {
        if (!count) return null;
        if (count < 1000) return `${count} views`;
        if (count < 1000000) return `${Math.round(count / 1000)}K views`;
        return `${(count / 1000000).toFixed(1)}M views`;
    };

    return (
        <div className="videos-section">
            <div className="video-grid">
                {videos.map((video, index) => {
                    const isSelected = selectedVideo && (
                        selectedVideo.display_id === video.display_id ||
                        (selectedVideo.url && video.url && selectedVideo.url === video.url)
                    );
                    const views = formatViewCount(video.view_count);
                    const durationLabel = formatDuration(video.duration);
                    // eslint-disable-next-line no-unused-vars -- used in JSX meta line below
                    const statsLine = [durationLabel !== '0:00' ? durationLabel : null, views]
                        .filter(Boolean)
                        .join(' • ');

                    return (
                    <button
                        type="button"
                        key={video.display_id || index}
                        className={`video-card ${isSelected ? 'selected' : ''}`}
                        onClick={() => onVideoSelect && onVideoSelect(video)}
                        aria-pressed={Boolean(isSelected)}
                        aria-label={`Play ${cleanTitle(video.title)}`}
                    >
                        <div className="video-thumbnail">
                            <CatalogThumb video={video} index={index} listLength={videos.length} />
                            {video.duration && <span className="video-duration">{formatDuration(video.duration)}</span>}
                        </div>
                        <div className="video-card-info">
                            <div className="video-card-title">
                                {cleanTitle(video.title)}
                            </div>
                            <div className="video-card-meta">
                                <span>{video.uploader || 'Source unavailable'}</span>
                                {statsLine ? <span>{statsLine}</span> : null}
                            </div>
                        </div>
                    </button>
                )})}
            </div>
            {videos.length === 0 && !loading && (
                <div className="results-empty">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M16 16l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <h3>No matching videos</h3>
                    <p>Try a different title, keyword, or link.</p>
                </div>
            )}
        </div>
    );
};

export default VideoGrid;